import { useContract } from "utils/contract"
import V1_SALE_ABI from "abis/sale.json"
import { Contract } from "ethers"

export function useV1SaleContract(contractAddress: string): Contract | null {
  return useContract(contractAddress, V1_SALE_ABI)
}
